<template>
  <div class="gauge" id='gauge' style='width: 156px;height: 128.7px;'>
  </div>
</template>

<script>
  export default {
    name: "gauge",
    props: {
      value: {
        type: Number,
      }
    },
    components: {},
    data() {
      return {
        myChart: null,
      }
    },
    methods: {
      initEcharts(data) {
        this.myChart = null
        var echarts = require('echarts');
        this.myChart = echarts.init(document.getElementById('gauge'));
        let option = {
          angleAxis: {
            show: false,
            max: 100 * 360 / 270, //-45度到225度，二者偏移值是270度除360度
            type: 'value',
            startAngle: 225, //极坐标初始角度
            splitLine: {
              show: false
            }
          },
          barMaxWidth: 6, //圆环宽度
          radiusAxis: {
            show: false,
            type: 'category',
          },
          //圆环位置和大小
          polar: {
            center: ['50%', '50%'],
            radius: '113'
          },
          series: [{
            type: 'bar',
            data: [{ //上层圆环，显示数据
              value: data,
              itemStyle: {
                color: { //图形渐变颜色方法，四个数字分别代表，右，下，左，上，offset表示0%到100%
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1, //从左到右 0-1
                  y2: 0,
                  colorStops: [{
                    offset: 0,
                    color: '#4735F8'
                  }, {
                    offset: 1,
                    color: '#54FDF1'
                  }],
                },
              },
            }],
            barGap: '-100%', //柱间距离,上下两层圆环重合
            coordinateSystem: 'polar',
            roundCap: true, //顶端圆角
            z: 2 //圆环层级，同zindex
          },
            { //下层圆环，显示最大值
              type: 'bar',
              data: [{
                value: 100,
                itemStyle: {
                  color: { //图形渐变颜色方法，四个数字分别代表，右，下，左，上，offset表示0%到100%
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1, //从左到右 0-1
                    y2: 0,
                    colorStops: [{
                      offset: 0,
                      color: '#153E58'
                    }, {
                      offset: 1,
                      color: '#12175A'
                    }],
                  },
                }
              }],
              barGap: '-100%',
              coordinateSystem: 'polar',
              roundCap: true,
              z: 1
            },
            //仪表盘
            {
              name: 'AQI',
              type: 'gauge',
              startAngle: 225, //起始角度，同极坐标
              endAngle: -45, //终止角度，同极坐标
              axisLine: {
                show: false,
              },
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false
              },
              splitLabel: {
                show: false
              },
              pointer: {
                show: false
              },
              title: {
                offsetCenter: [0, 10],
                color: '#B8D7FF',
                fontSize: 32,
                fontWeight: 500,
                rich: {
                  a: {
                    fontWeight: 'normal',
                    fontSize: 17,
                    color: '#B8D7FF',
                    lineHeight: 40,
                  }
                }
              },
              detail: {
                show: false,
              },
              data: [{
                value: data,
                name: data + '%\n' + '{a|' + '溢价率' + '}'

              }]
            }
          ]
        }
        this.myChart.setOption(option)
      },
    },
    created() {

    },
    watch:{
      value:function () {
        this.$nextTick(function () {
          console.log(this.value);
          this.initEcharts(this.value)
        })
      }
    },
    mounted() {
      this.$nextTick(function () {
        console.log(this.value);
        this.initEcharts(this.value)
      })
    },
  }
</script>

<style scoped lang="scss">
  .gauge {

  }
</style>
